<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="postFlightVisibilityAudits && postFlightVisibilityAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="postFlightVisibilityAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No PostFlight Visibility audits </ng-template>
</ng-template>
